"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveGutterLength = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _spacing = require("../../../constants/spacing");
// a ScrollAreaGutter that resolves to a single CSS length value (as opposed to a shorthand value)

const isLodestarSizeKey = key => {
  return key in _spacing.sizes;
};
const isUrsaSpaceKey = key => {
  return key in _designTokens.space;
};

// map a SingleLengthGutter to one CSS length string
// this assumes Lodestar and Ursa constant names remain mutually exclusive
const resolveGutterLength = gutter => {
  if (isLodestarSizeKey(gutter)) {
    return `${_spacing.sizes[gutter]}px`;
  }
  if (isUrsaSpaceKey(gutter)) {
    return _designTokens.space[gutter];
  }
  return "0px";
};
exports.resolveGutterLength = resolveGutterLength;
//# sourceMappingURL=resolveGutterLength.js.map